/** P&R REAL VALUE — 4 automated Puppeteer templates (must match server prTemplateConfig.ts). */
export const PR_TEMPLATE_P_DE = '6a801a2b3c4d5e6f70100001';
export const PR_TEMPLATE_P_EN = '6a801a2b3c4d5e6f70100002';
export const PR_TEMPLATE_R_DE = '6a801a2b3c4d5e6f70100003';
export const PR_TEMPLATE_R_EN = '6a801a2b3c4d5e6f70100004';

export const PR_REAL_VALUE_TEMPLATE_IDS = [
  PR_TEMPLATE_P_DE,
  PR_TEMPLATE_P_EN,
  PR_TEMPLATE_R_DE,
  PR_TEMPLATE_R_EN,
] as const;

import prInvestmentLogo from '../../../../../assets/images/pr-investment-logo.png';

/** Public-folder fallback; preview should prefer the webpack-bundled PNG import. */
export const PR_LOGO_PUBLIC_PATH = '/images/pr-investment-logo.png';

/** Webpack-bundled logo, so the editor preview never depends on S3/Mongo icon_url. */
export const PR_LOGO_ASSET: string = prInvestmentLogo;

export function isPrRealValueTemplate(templateId?: string | null): boolean {
  if (!templateId) return false;
  return (PR_REAL_VALUE_TEMPLATE_IDS as readonly string[]).includes(String(templateId));
}

export type PrShareClassCode = 'P' | 'R';
export type PrLocaleCode = 'de' | 'en';

export type PrTemplateVariant = {
  templateId: string;
  shareClass: PrShareClassCode;
  locale: PrLocaleCode;
  isin: string;
  wkn: string;
  bloomberg: string;
  inception: string;
  minInvestment: string;
  footerLabel: string;
};

/** Mirrors server `prTemplateConfig.ts`; keep both lists in sync. */
export const PR_TEMPLATE_VARIANTS: PrTemplateVariant[] = [
  {
    templateId: PR_TEMPLATE_P_DE,
    shareClass: 'P',
    locale: 'de',
    isin: 'LU0855492194',
    wkn: 'A1J3KX',
    bloomberg: 'PNRREAL LX',
    inception: '27.12.2012',
    minInvestment: '10.000 EUR',
    footerLabel: 'Factsheet - Anteilklasse P',
  },
  {
    templateId: PR_TEMPLATE_P_EN,
    shareClass: 'P',
    locale: 'en',
    isin: 'LU0855492194',
    wkn: 'A1J3KX',
    bloomberg: 'PNRREAL LX',
    inception: '27.12.2012',
    minInvestment: '10,000 EUR',
    footerLabel: 'Factsheet - Share Class P',
  },
  {
    templateId: PR_TEMPLATE_R_DE,
    shareClass: 'R',
    locale: 'de',
    isin: 'LU2941484342',
    wkn: 'A40V7D',
    bloomberg: 'PRRLVLR LX',
    inception: '02.01.2025',
    minInvestment: 'keines',
    footerLabel: 'Factsheet - Anteilklasse R',
  },
  {
    templateId: PR_TEMPLATE_R_EN,
    shareClass: 'R',
    locale: 'en',
    isin: 'LU2941484342',
    wkn: 'A40V7D',
    bloomberg: 'PRRLVLR LX',
    inception: '02.01.2025',
    minInvestment: 'none',
    footerLabel: 'Factsheet - Share Class R',
  },
];

/**
 * The template id is the source of truth for language / share class, so a DE
 * template always renders German even when `additional_fields.prLocale` is
 * missing or stale.
 */
export function getPrTemplateVariant(templateId?: string | null): PrTemplateVariant | undefined {
  if (!templateId) return undefined;
  return PR_TEMPLATE_VARIANTS.find((variant) => variant.templateId === String(templateId));
}

/**
 * Preview logo: always prefer the webpack-bundled asset. Never rely on Mongo/S3
 * `icon_url` (local disk paths and private S3 URLs show as a broken image with alt
 * text "P&R"); only use it as a last resort when it is an embedded data URL.
 */
export function resolvePrLogoUrl(iconUrl?: string | null): string {
  if (PR_LOGO_ASSET) return PR_LOGO_ASSET;
  if (iconUrl && iconUrl.startsWith('data:')) return iconUrl;
  return PR_LOGO_PUBLIC_PATH;
}
